import React, { PropsWithChildren } from 'react';
import {
  Divider,
  Gap,
  Gutter,
  Paragraph,
  Text,
  TimeWithTimeZone,
} from '@common/components';
import { Colors } from '@common/tokens';

export type ChangeRequestDialogBoxProps = {
  changeRequest?: ChangeRequestType;
};

type ChangeRequestType = {
  updatedAt: string;
  note: string;
  worksMembership: {
    name: string;
  };
  offerChangeResponse?: {
    updatedAt: string;
    note: string;
    worksMembership: {
      name: string;
    };
  } | null;
};

export function ChangeRequestDialogBox({
  changeRequest,
  children,
}: PropsWithChildren<ChangeRequestDialogBoxProps>) {
  const request = getChangeRequestDialog(changeRequest);
  const { response } = request;

  return (
    <>
      <div className="offer-change-dialog-box">
        <Gutter asPadding size="md">
          <DialogMessage
            title="Change Request"
            note={request.note}
            name={request.userName}
            date={request.date}
          />
          {children && <Gutter direction="top">{children}</Gutter>}
          {response && (
            <>
              <Divider gutter={16} />
              <DialogMessage
                title="Reply"
                note={response.note}
                name={response.userName}
                date={response.date}
              />
            </>
          )}
        </Gutter>
      </div>
      <style jsx>{`
        .offer-change-dialog-box {
          border-radius: 4px;
          background: ${Colors.steelLightest};
          border: 1px solid ${Colors.steel};
        }
      `}</style>
    </>
  );
}

function DialogMessage({
  title,
  note,
  name,
  date,
}: {
  title: string;
  note: string;
  name: string;
  date: string;
}) {
  return (
    <div className="offer-change-dialog-box__message">
      <Gap vertical>
        <header>
          <Text bold size="lg">
            {title}
          </Text>
        </header>
        <Paragraph size="lg">&quot;{note}&quot;</Paragraph>
        <footer>
          <Text size="lg" italic secondary>
            {`${name}, `}
            <TimeWithTimeZone date={date} variant="long_format" />
          </Text>
        </footer>
      </Gap>
    </div>
  );
}

function getChangeRequestDialog(request?: ChangeRequestType): {
  note: string;
  userName: string;
  date: string;
  response?: {
    note: string;
    userName: string;
    date: string;
  };
} {
  const response = request?.offerChangeResponse;
  return {
    note: request?.note ?? '',
    userName: request?.worksMembership.name ?? '',
    date: request?.updatedAt ?? '',
    response: response
      ? {
          note: response.note,
          userName: response.worksMembership.name,
          date: response.updatedAt,
        }
      : undefined,
  };
}
